Object.defineProperty(Object.prototype, "nsg", {
  enumerable: false,
  writable: false,
  value: function(p) {
    if (!p) throw new Error("[nsg] empty value!");
    return p.split(".").reduce((acc, k) => {
      if (acc && k in acc) return acc[k];
      return "";
    }, this);
  }
});
